import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';

import classes from './NoAccess.module.css';

const NoAccess = props => {
  const { t } = useTranslation(['noAccess']);
  const dataAcademy = useSelector(state => state.academyInfo);

  return (
    <aside className={classes.noAccessContainer}>
      <h3 className={classes.title}>{t('title')}</h3>
      {dataAcademy.data.productType === 1 ? (
        <>
          <p className={classes.text}>{t('loginText')}</p>
          <Button
            className={classes.buyBtn}
            component={Link}
            to="/login"
          >
            {t('login')}
          </Button>
        </>
      ) : (
        <>
          <p className={classes.text}>{t('text')}</p>
          <Button
            className={classes.buyBtn}
            component="a"
            target="_blank"
            href={`https://pagos.mayahii.com/cart/checkout/academy/course/${props.idEmisor}/${props.academyName}/${props.idCourse}`}
          >
            {t('buy')}
          </Button>
        </>
      )}
    </aside>
  );
};

NoAccess.propTypes = {
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idEmisor: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  academyName: PropTypes.string
};

export default NoAccess;
